import React from "react";
import CountUp from "react-countup";

export const Banner = ({ conf, vacc, recov, dead }) => {
  return (
    <div className="banner-container">
      <div className="icons ">
        <span className="fas fa-virus"></span>
        <span className="title">Confirmed</span>
        <span>
          <CountUp start={0} end={conf} duration={5} />
        </span>
      </div>
      <div className="icons ">
        <span className="fas fa-syringe"></span>
        <span className="title">Vaccinations</span>
        <span>
          <CountUp start={0} end={vacc} duration={5} />
        </span>
      </div>
      <div className="icons ">
        <span className="fas fa-heart"></span>
        <span className="title">Recovered</span>
        <span>
          <CountUp start={0} end={recov} duration={5} />
        </span>
      </div>
      <div className="icons">
        <span className="fas fa-skull"></span>
        <span className="title">Deaths</span>
        <span>
          <CountUp start={0} end={dead} duration={5} />
        </span>
      </div>
    </div>
  );
};
